import React, { useCallback, useEffect, useState } from "react";
import { HeroSm, MyInput, NavBar, Spinner } from "../components";
import { Footer } from "../layouts";
import $ from "jquery";
import { Slang, useIsTokenValid } from "../helpers";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../store";
import axios from "axios";
import { fetchWrapper } from "../helpers/fetch-wrapper";
import config from "../config";
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
} from "react-google-recaptcha-v3";
import { clearCart, setUUID } from "../store/cart.slice";

const Login = () => {
  const [loadPage, setLoadPage] = useState(true);

  useEffect(() => {
    let tim2 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    return () => {
      clearInterval(tim2);
    };
  }, []);

  if (useIsTokenValid(true)) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <>
      {loadPage ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
            }}
          >
            <Spinner color={"success"} size={3} />
          </div>
        </>
      ) : (
        <Main />
      )}
    </>
  );
};

export default Login;

const Main = () => {
  const [token, setToken] = useState(null);
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [data, setData] = useState({
    ip: "",
    email: "",
    password: "",
    account_type: "Company",
    recaptchaToken: "",
  });
  const lang = Slang("navbar");
  const langRegister = Slang("Register");
  const pInfoLang = Slang("Register.PersonnalsInfo");
  const uuid = useSelector((state) => state.cart.uuid);

  useEffect(() => {
    const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

    $("body").append(`<script className="homescript">${script}</script>`);

    getIpAddress();

    return () => {
      $(".homescript").remove();
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value.trim() });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const ip = sessionStorage.getItem("ip");
    console.log("login ip", ip);

    const recaptchaToken = sessionStorage.getItem("reCaptchaToken");
    fetchWrapper
      .post(`${config.apiUrl}/user/login`, { ...data, ip, recaptchaToken })
      .then((response) => {
        const { data } = response;
        const { user } = data;
        console.log("login data", data);

        setSubmitted(false);
        if (user?.email_verified_at) {
          setAuthenticated();
          setAuthToken(data);
          setUser(data);

          if (user.uuid === null) {
            setCartUUID(user);
          } else if(user.uuid !== uuid ) {
            setCartUUID(user);
            handleClearingCart();
          }

          // sessionStorage.setItem('token', data.token.value);
          navigate("/dashboard");
        } else {
          setAuthToken(data);
          navigate("/verify-email");
        }
      })
      .catch((e) => {
        setError(e.response.data.message);
        console.log("error login", e);

        setRefreshReCaptcha((r) => !r);
        setSubmitted(false);
        if (e === "Your account has not been verified") {
          navigate("/verify-email");
        }
      });
  };

  const setAuthToken = (data) => {
    dispatch(authActions.setToken(data.token));
  };
  const setUser = (data) => {
    dispatch(authActions.setUser(data.user));
  };
  const setAuthenticated = () => {
    dispatch(authActions.setIsAuth(true));
  };
  const setCartUUID = (user) => {
    dispatch(setUUID(user.uuid));
  };
  const handleClearingCart = () => {
    dispatch(clearCart());
  };

  const getIpAddress = () => {
    axios.get("https://api.ipify.org/?format=json").then((response) => {
      sessionStorage.setItem("ip", response.data.ip);
      setData({ ...data, ip: response.data.ip });
    });
  };
  const onVerify = useCallback((token) => {
    sessionStorage.setItem("reCaptchaToken", token);
    setToken(token);
  }, []);
  return (
    <>
      {/*{window.location.pathname === "add-business" ? <NavBar /> : null}*/}
      <NavBar />
      <HeroSm title={lang("t6")} />
      <main id="content" role="main">
        <div className="container content-space-3 content-space-t-lg-1 content-space-b-lg-3">
          <div className="flex-grow-1 mx-auto" style={{ maxWidth: "28rem" }}>
            <div className="text-center mb-5 mb-md-7">
              <h1 className="h2">
                <img
                  src="./assets/img/logos/155x47/initial/PNG/init_gradient.png"
                  alt="logo"
                  style={{ height: "7vh" }}
                />
              </h1>
            </div>

            <form
              onSubmit={handleSubmit}
              className="js-validate needs-validation"
            >
              <div className="mb-3">
                <MyInput
                  required
                  error={error}
                  handleChange={handleChange}
                  id="email"
                  name="email"
                  placeholder="email@site.com"
                  type="email"
                  label={pInfoLang("t4")}
                />
              </div>

              <div className="mb-3">
                <MyInput
                  required
                  handleChange={handleChange}
                  id="password"
                  name="password"
                  placeholder={pInfoLang("t6")}
                  label={pInfoLang("t6")}
                  type="password"
                />
              </div>
              <GoogleReCaptchaProvider
                reCaptchaKey={config.googleReCaptchaClientId}
              >
                <GoogleReCaptcha
                  className="google-recaptcha-custom-class"
                  onVerify={onVerify}
                  refreshReCaptcha={refreshReCaptcha}
                />
              </GoogleReCaptchaProvider>
              <br />
              <div className="d-grid mb-3 col-md-12 col-sm-12">
                <button
                  disabled={submitted}
                  type="submit"
                  className="btn btn-primary btn-lg"
                >
                  {submitted ? <Spinner color="light" /> : lang("t6")}
                </button>
                {/*<button disabled={submitted} type="submit" className="btn btn-primary btn-lg">*/}
                {/*    {submitted ? <Spinner color="light"/> : lang('t6')}*/}
                {/*</button>*/}
              </div>
            </form>
            <div className="text-center">
              <p>
                {langRegister("t9")}{" "}
                <Link className="link" to="/register">
                  {langRegister("10")}
                </Link>
              </p>
              <p>
                <Link className="link" to="/forgot-password">
                  {langRegister("11")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
